import { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { io } from 'socket.io-client'
import config from 'config/app.config'
import NAMESPACES from 'socket-resources/namespaces/index'
import { WALLET_UPDATE_EVENT, MESH_TRANSFER_STATUS_EVENT } from 'socket-resources/event-constants/wallet/index'

// Singleton socket instance shared across all hook calls
let _socket = null
let _currentToken = null

const getSocket = (token) => {
  if (_socket && _currentToken === token && _socket.connected) {
    return _socket
  }
  if (_socket) {
    _socket.disconnect()
    _socket = null
  }
  _currentToken = token
  _socket = io(`${config.SOCKET_URL}${NAMESPACES.WALLET}`, {
    auth: { authorization: `Bearer ${token}` },
    reconnection: true,
    reconnectionAttempts: 10,
    reconnectionDelay: 1000
  })
  return _socket
}

const useWalletSocketNameSpace = () => {
  const { loginData } = useSelector(state => state.auth)
  const token = loginData?.accessToken

  const listenWalletUpdateEvent = (cb) => {
    if (!token) return () => {}
    const socket = getSocket(token)
    socket.on(WALLET_UPDATE_EVENT, cb)
    return () => {
      socket.off(WALLET_UPDATE_EVENT, cb)
    }
  }

  const listenMeshTransferStatus = (cb) => {
    if (!token) return () => {}
    const socket = getSocket(token)
    socket.on(MESH_TRANSFER_STATUS_EVENT, cb)
    return () => {
      socket.off(MESH_TRANSFER_STATUS_EVENT, cb)
    }
  }

  return { listenWalletUpdateEvent, listenMeshTransferStatus }
}

export default useWalletSocketNameSpace
